import CardCodesTemplate from "components/templates/CardCodesTemplate/CardCodesTemplate";

const CardCodesPage = () => <CardCodesTemplate />;

export default CardCodesPage;
